module.exports = __webpack_public_path__ + "img/home_slider_01.59c8880d.jpg";